export default __webpack_public_path__ + "static/media/check.d53c4327.png";